/**
 * @file For preventing scroll
 *
 *
 * @author Jostein Kirkebak
 * @version 1.0
 *
 *
 * The element that should be overlayed, must have a ref of overlay.
 * Props: (Put in data of main component)
 * offsetTopPercent
 * offsetTopPixels
 * includeWindowY
 * showHeader
 * scrollClose
 *
 */

export default {
  data () {
    return {
      scrollPosition: 0,
      scrollCloseValue: 0
    };
  },
  methods: {

    escClose (e) {
      if (e.key === 'Escape') {
        this.$emit('close');
      }
    },
    findOffset () {
      let offset = 0;
      if (this.offsetTopPercent) offset += window.innerHeight / 100 * this.offsetTopPercent;
      if (this.offsetTopPixels) offset += this.offsetTopPixels;
      if (this.includeWindowY) offset += window.scrollY;
      return offset;
    },
    lockScroll () {
      if (this.$refs.overlay) {
        // Finds the HTML element,
        const htmlElement = document.getElementsByTagName('html')[0];
        // Stores the current scroll position
        this.scrollPosition = window.scrollY;

        // Locks the header to current position, or forces it open if desired.
        if (this.showHeader) {
          this.$store.dispatch('appContext/setHideHeader', false);
        }
        this.$store.dispatch('appContext/setScrollLock', true);

        // Stores the current scroll position, and offsets the overlay element to desired offset.
        this.$refs.overlay.style.top = `${this.findOffset()}px`;
        // Locks the HTML element to the current position.
        htmlElement.style.top = `-${this.scrollPosition}px`;
        htmlElement.style.width = '100%';
        htmlElement.style.overflowY = 'scroll';
        htmlElement.style.position = 'fixed';
      } else {
        console.warn('Failed to acces the Overlay ref. Overlay element needs to be mounted before lockScroll is called.');
      }

      document.addEventListener('keydown', this.escClose);
    },
    freeScroll () {
      // Finds the HTML element and releases it.
      const htmlElement = document.getElementsByTagName('html')[0];
      htmlElement.style.position = 'static';
      htmlElement.style.overflowY = 'auto';
      htmlElement.style.width = 'unset';

      // Sets scroll position to the original position before overlay was opened.
      window.scrollTo({ left: 0, top: this.scrollPosition });

      document.removeEventListener('keydown', this.escClose);

      // Frees up the header, and keeps it open if desired.
      this.$store.dispatch('appContext/setScrollLock', false);
      if (this.showHeader) {
        this.$store.dispatch('appContext/setHideHeader', false);
      }
    }
  }
};
